export default __webpack_public_path__ + "static/media/discovery.a0fd547c.svg";